window.BoostDom = {
	map: {
		body: "body",
		window,
		document,
		container: "#boosts",
		page: "#page",

		modal: "#boost_purchase_modal",
		modal_success: "#boost_purchase_success",
		modal_slide: ".selectboosts-item--slide-controller-button",
		modal_slide_wrapper: ".selectboosts-item--slides",
		panel: "#boosts .panel-boost",
		activity: "#im_footer",
		autoboost: "#autoboost_info",

		button_open: ".nav-boost .nav-boost-open",
		button_open_text: ".nav-boost .nav-boost-open .tokens",
		button_closereport: "#boosts .boost-report-close",
		button_closeactivity: "#boost_activity_toggler .close",
		button_boostagain: "#boosts .boost-report-reactivate",
		button_cancel: "#boosts .boost-running-cancel",
		button_subspromo: "#boosts .boost-subspromo-open, .boostsubs-upgrade-link",

		button_buy: "#boost_purchase_modal .boost-buy",
		button_close: "#boost_purchase_modal .boost-cancel",

		progress_bar: "#boosts .panel-boost .boost-running .boost-progress .bar",
		viewer_thumbs: "#boosts .panel-boost .boost-running .boost-running-people",

		button_togglepkgs: "#boost_purchase_modal .selectboosts-type-pkgs",
		button_togglesubs: "#boost_purchase_modal .selectboosts-type-subs",

		tokenpackages: "#boost_purchase_modal .boost-select-packages li",
		tokenpackageradios: "#boost_purchase_modal .boost-select-packages input[type=radio]",

		subpackages: "#boost_purchase_modal .boost-select-subs li",
		subpackageradios: "#boost_purchase_modal .boost-select-subs input[type=radio]",

		form_package: "#boost_purchase_modal .boost-select-form",

		ads: ".okmasthead, #leaderboard_wrapper, .okad",

		rushhour_modal: '#rush_hour_modal',
		rushhour_promote: '#rush_hour_promote',
		rushhour_close: '#rush_hour_dismiss',

		button_boost_intro_popover: '#nav-boost-intro-popover .continue',

		button_usernav_open: ".usernavboost .nav-user-menu-item",
		button_usernav_open_text: ".usernavboost-tokens"
	},

	init() {
		const result = [];

		Object.keys(this.map).forEach((name) => {
			const selector = this.map[name];
			result.push(this[name] = $(selector));
		});

		return result;
	}
};



// WEBPACK FOOTER //
// ./src/legacy/boosts/dom.js